export enum EstrattoActionType {
  FETCH_ESTRATTO = 'FETCH_ESTRATTO',
  FETCH_RIEPILOGO_MATERIALE = 'FETCH_RIEPILOGO_MATERIALE',
  FETCH_DETTAGLIO_MOVIMENTI = 'FETCH_DETTAGLIO_MOVIMENTI',
  FETCH_ESTRATTO_DATES = 'FETCH_ESTRATTO_DATES',
  FETCH_ESTRATTO_MATERIALS = 'FETCH_ESTRATTO_MATERIALS',
  SAVE_ESTRATTO_MATERIALS = 'SAVE_ESTRATTO_MATERIALS',
  EXPORT_ESTRATTO_MATERIALS = 'EXPORT_ESTRATTO_MATERIALS'
}
